import React, { useContext } from "react";
// React Bootstrap
import { Button } from "react-bootstrap";
// Componentes
import VistaCanonicos from "../vistas/VistaCanonicos";
import FormCanonicos from "../formularios/FormCanonicos";
// Contexto
import { ModalContext } from "../../../context/modalContext";

const Canonicos = ({ datosComunidad, handlePutDatosComunidad, permisoEdicion}) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

  return (
    <React.Fragment>
      <VistaCanonicos datosComunidad={datosComunidad} />
      {permisoEdicion && <Button
        variant="outline-primary"
        size="sm"
        className="float-right mr-4"
        onClick={() => {
          modalSetShow(true, "80%");
          modalSetTitle(`Editar datos canonicos`);
          modalSetContent(<FormCanonicos defaultValues={datosComunidad} submissionHandler={handlePutDatosComunidad} />);
        }}
      >
        Editar
      </Button>}
    </React.Fragment>
  );
};

export default Canonicos;
